import UserStore from '../stores/user_store';

import util from '../tools/util';

export default { createUserRequest };

interface CreateUserRequestParams {
  org_id: number;
  media_grant_id: number;
  media_id_list: number[];
}
export function createUserRequest(params: CreateUserRequestParams, done) {
  const { org_id, media_grant_id, media_id_list } = params;
  const opts = {
    url: `/web/1/org/${org_id}/media_grant/${media_grant_id}/user_request`,
    body: { media_id_list },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserRequestStore.createUserRequest: err:', err, body);
    }
    done(err);
  });
}
